module.exports = __webpack_public_path__ + "ebeeb7c3e64e9f82ccd14748ead28fc2.png";